import Link from "next/link";

import { useEventTracker } from "@/hooks/useEventTracker";

import Image from "@/components/Image";
import TrackImpression from "@/components/TrackImpression";

type Props = {
  link?: string | null;
  title?: string | null;
  image?: string | null;
  eventCategory?: string;
};

const Tile = ({ link, title, image, eventCategory }: Props) => {
  const { publishEvent } = useEventTracker();

  return link && title && image ? (
    <TrackImpression
      category={eventCategory}
      label={title}
      className="col md:col-1/2 mb-md"
      style={{ height: 130 }}
    >
      <Link
        href={link}
        className="block h-full w-full overlay-gradient-black rounded shadow-low overflow-hidden"
        onClick={() => {
          if (eventCategory) {
            publishEvent({
              action: "Click",
              category: eventCategory,
              label: title,
            });
          }
        }}
      >
        {title && (
          <div className="text-white absolute p-lg bottom-0 z-10">
            <h3 className="font-normal text-sm">{title}</h3>
          </div>
        )}
        {image && (
          <Image
            src={image}
            sizes={[300]}
            background
            alt={""}
            backgroundPosition="center right"
          />
        )}
      </Link>
    </TrackImpression>
  ) : null;
};

export default Tile;
